export default function Spinner() {
  return (
    <div className="w-5 h-5 border-[3px] border-solid border-l-primaryColor border-t-lighterGrey border-r-lighterGrey border-b-lighterGrey rounded-full animate-spin"></div>
  );
}
